<template>
    <v-select
        v-model="model"
        :items="items"
        :label="title"
        variant="outlined"
        density="compact"
        @update:model-value="onSelectItem($event)"
        clearable
    ></v-select>
</template>

<script lang="ts" setup>
    import { useListUtils } from '~/composables';
    import { ProductAssortmentType } from '~/types';

    const props = withDefaults(
        defineProps<{
            modelValue: Nilish<string>;
            title: string;
            omit?: string[];
        }>(),
        {
            modelValue: null,
            omit: () => []
        }
    );

    const emit = defineEmits<{
        'update:modelValue': [value: string];
    }>();


    const model = ref<Nilish<string>>(`${props.modelValue}`);
    const items = reactive(useListUtils().enumToGenericList(ProductAssortmentType, {}, props.omit));

    const unWatchProps = watch(
        () => props.modelValue,
        (newVal, oldVal) => {
            if (!newVal) {
                model.value = null;
            }
        },
        {
            immediate: true
        }
    );

    function onSelectItem(item: string) {
        emit('update:modelValue', item);
    }

    onBeforeUnmount(() => {
        unWatchProps();
    });
</script>

<style lang="scss"></style>
